"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.number.constructor.js");

var _utils = require("@/utils");

var state = {
  reportDevice: 1
};
var mutations = {
  SET_REPORT_DEVICE: function SET_REPORT_DEVICE(state, reportDevice) {
    state.reportDevice = reportDevice;
  }
};
var actions = {
  restoreDevice: function restoreDevice(_ref, _ref2) {
    var commit = _ref.commit,
        state = _ref.state;
    var _ref2$reportDevice = _ref2.reportDevice,
        reportDevice = _ref2$reportDevice === void 0 ? 1 : _ref2$reportDevice;

    if (reportDevice === -1) {
      reportDevice = localStorage.getItem((0, _utils.getStorageKey)('reportDevice'));
    }

    if (reportDevice === undefined) {
      reportDevice = 1; // 默认为中档
    }

    reportDevice = Number(reportDevice);
    commit('SET_REPORT_DEVICE', reportDevice);
  }
};
var _default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};
exports.default = _default;